import {mixins} from "../app/mixin";

mixins.push({
    el: '.ourValues',
    data: () => ({
        selectedOurValuesItem: 0,
    }),
    methods: {
        selectOurValuesItem(itemId) {
            if (this.selectedOurValuesItem !== itemId) {
                this.selectedOurValuesItem = itemId
            }
            TODO
        },
    },
});